<template>
<base-popup
    :popup-model="show"
    :title="formTitle"
    :valid="!valid"
    :width="50"
    @onCancelButtonClick="closePopupHandler"
    @onSaveButtonClick="saveItemHandler"
>
  <v-form
      :ref="formRef"
      v-model="valid"
      lazy-validation
  >
    <v-container class="ma-2 mt-3">
      <div v-if="currentItem.type === 1000"><span class="text--black" style="font-size: 18px">Note:</span> If you add some variable into your template, use like: @name. Usable variables <b>(email, mergedNo, description, amount, discount, totalAmount, invoicesNo, links, createdAt, payLink)</b> </div>
      <div v-else><span class="text--black" style="font-size: 18px">Note:</span> If you add some variable into your template, use like: @name. Usable variables <b>(name, email, totalAmount, amount, discount, invoiceNo, refcode, createdAt, payLink, links)</b> </div>
      <v-row class="mt-2">
    <v-col cols="12">
      <v-text-field
      v-model="currentItem.name"
      label="Template Name"
      :rules="requiredFieldRule"
      dense
      outlined
      />
      <v-text-field
          v-model="currentItem.subject"
          label="Mail Subject"
          :rules="requiredFieldRule"
          dense
          outlined
      />
      <vue-editor
          v-model="currentItem.description"
          :editorToolbar="customToolbar"
          :customModules="customModulesForEditor"
          :editorOptions="editorSettings"
          useCustomImageHandler
          @image-added="handleImageAdded"
      />
    </v-col>
  </v-row>
    </v-container>
  </v-form>
</base-popup>
</template>

<script>
import BasePopup from "./BasePopup";
import Popup from "../mixins/Popup";
import { VueEditor, Quill } from "vue2-editor";
import ImageResize from 'quill-image-resize-vue';
import MailTemplate from "@/services/MailTemplate";
Quill.register("modules/imageResize", ImageResize);
export default {
  name: "MailTemplateEditorPopup",
  mixins:[Popup],
  components: {
    BasePopup,
    VueEditor
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ color: [] }, { background: [] }],
        ["blockquote", "code-block", "link", "image"]
      ],
      customModulesForEditor: [
        { alias: "imageResize", module: ImageResize }
      ],
      editorSettings: {
        modules: {
          imageResize: {}
        }
      }
    }
  },
  computed: {
    formTitle() {
      return this.isEditMode ? 'Edit Mail Template' : 'Add Mail Template'
    }
  },
  methods: {
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      MailTemplate
          .imageUpload({tempImage: file, tempName: this.currentItem.name})
          .then((result) => {
            const url = result.data.url;
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          })
          .catch((errors)=> {

          })

    }
  }
}
</script>

<style scoped>

</style>